import React, { Component } from "react";
import Close from "../../../../../Icons/Close";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import WebcamCapture from "./WebcamCapture";
import WebcamStreamCapture from "./WebcamStreamCapture";
import { makeStyles } from "@material-ui/core/styles";
import { attachFiles, attachVideo } from "../Communaute.duck";
import { connect } from "react-redux";
import _ from "lodash";
import { openSnackBar } from "../../../../../reducers";
import imgUrlAvatar from "../../../../../styles/img/enfant-avatar.jpg";

const divStyleAvatar = {
  background: "url(" + imgUrlAvatar + ")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundSize: "cover",
};
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

class MediaPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadPhoto: false,
      cameraPhoto: false,
      src: null,
      tabActive: "arrivee-tab",
      onlyView: false,
      tabToUpdate: "",
      isUpdate: false,
      file: null,
      snackBarStatus: false,
      valid: true,
      selectedAttachment: "",
    };
    this.handleTab = this.handleTab.bind(this);
    this.activeUpload = this.activeUpload.bind(this);
    this.activeCamera = this.activeCamera.bind(this);
    this.activeVideo = this.activeVideo.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.attachFiles = this.attachFiles.bind(this);
    this.toMega = this.toMega.bind(this);
    this.handleCapturedImage = this.handleCapturedImage.bind(this);
  }
  handleCapturedImage = (src) => {
    let reader = new FileReader();
    let file = src;

    reader.onloadend = () => {
      this.setState({
        file: file,
      });
    };

    reader.readAsDataURL(file);
  };
  handleClick = () => {};

  activeUpload(string) {
    return this.state.tabActive === string ||
      this.state.tabActive === "depart-tab"
      ? "active"
      : "";
  }
  activeCamera(string) {
    return this.state.tabActive === string ||
      this.state.tabActive === "arrivee-tab"
      ? "active"
      : "";
  }
  activeVideo(string) {
    return this.state.tabActive === string ||
      this.state.tabActive === "video-tab"
      ? "active"
      : "";
  }
  handleTab = (string) => {
    if (!_.isEmpty(this.props.dataPost.files) && string === "video-tab") {
      let name = "";
      let message = "Impossible de mixer les photos et les vidéo";
      this.props.openSnackBar(name, message);
    } else {
      this.setState({ tabActive: string });
    }
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result, uploadPhoto: true })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  switchTabs(tab) {
    switch (tab) {
      case "depart-tab":
        return <div></div>;
      case "arrivee-tab":
        return (
          <WebcamCapture
            handleCapturedImage={this.handleCapturedImage}
            onCloseModalePhoto={this.props.onCloseModalePhoto}
          />
        );
      case "video-tab":
        return (
          <WebcamStreamCapture
            onCloseModalePhoto={this.props.onCloseModalePhoto}
          />
        );

      default:
        return null;
    }
  }
  attachFiles(e) {
    let files = Object.values(e.target.files);
    let videos = files.filter((element) => {
      return element.type === "video/mp4";
    });
    let photoSizeUp = files.filter((element) => {
      let sizeInMB = (element.size / (1024 * 1024)).toFixed(2);
      return element.type !== "video/mp4" && sizeInMB > 5;
    });
    let photoSizeDown = files.filter((element) => {
      let sizeInMB = (element.size / (1024 * 1024)).toFixed(2);

      return element.type !== "video/mp4" && sizeInMB <= 5;
    });
    if (photoSizeUp.length) {
      let name = "";
      let message = "Impossible d'ajouter des photos supérieur à 5 méga";
      this.props.openSnackBar(name, message);
    }

    if (this.props.dataPost.files.length + e.target.files.length > 30) {
      let name = "";
      let message = "Impossible d'ajouter plus que 30 image";
      this.props.openSnackBar(name, message);
    }
    if (videos.length > 1) {
      let name = "";
      let message = "Impossible d'ajouter plus qu'un media de type video";
      this.props.openSnackBar(name, message);
    }
    if (
      (videos.length && e.target.files.length > 1) ||
      (videos.length && this.props.dataPost.files.length > 0)
    ) {
      let name = "";
      let message = "Impossible de mixer les photos et les vidéo";
      this.props.openSnackBar(name, message);
    }

    if (videos.length === 1) {
      let size = this.toMega(videos[0].size);
      size = size.split(" ", 1);
      if (parseFloat(size) > 25) {
        let name = "";
        let message =
          "Impossible d'ajouter un vidéo de taille supérieur à 25 Méga";
        this.props.openSnackBar(name, message);
      } else {
        this.props.attachVideo(files[0]);
        this.props.onCloseModalePhoto();
      }
    }
    if (photoSizeDown.length) {
      this.props.attachFiles(photoSizeDown);
      this.props.onCloseModalePhoto();
    } else {
      return;
    }
  }

  toMega = (aSize) => {
    aSize = Math.abs(parseInt(aSize, 10));
    var def = [
      [1, "octets"],
      [1024, "ko"],
      [1024 * 1024, "Mo"],
      [1024 * 1024 * 1024, "Go"],
      [1024 * 1024 * 1024 * 1024, "To"],
    ];
    for (var i = 0; i < def.length; i++) {
      if (aSize < def[i][0])
        return (aSize / def[i - 1][0]).toFixed(2) + " " + def[i - 1][1];
    }
  };

  render() {
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));

    return (
      <div
        className="modal show modal-skin modal-full  "
        style={{ display: "show" }}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog " role="document">
          <div className="modal-content">
            <button
              onClick={() => this.props.onCloseModalePhoto()}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <Close className="img-fluid" alt="" />
            </button>
            <div className="modal-body">
              <div
                className="mt-3 d-flex align-items-center justify-content-center"
                style={{ paddingBottom: 10 }}
              >
                <button
                  className={`btn-filter ${this.activeCamera("arrivee-tab")}`}
                  style={{ cursor: "pointer" }}
                  id="arrivee-tab"
                  onClick={() => this.handleTab("arrivee-tab")}
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  <span>Photo</span>
                </button>
                <div className={classes.root}>
                  <input
                    className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: "none" }}
                    onChange={this.attachFiles}
                    accept="video/mp4,image/png,image/bmp,image/jpeg"
                  />
                  <button
                    className={`btn-filter ${this.activeVideo("video-tab")}`}
                    style={{ cursor: "pointer" }}
                    id="video-tab"
                    onClick={() => this.handleTab("video-tab")}
                    role="tab"
                    aria-controls="contact"
                    aria-selected="false"
                  >
                    <span>Vidéo</span>
                  </button>
                  <label
                    htmlFor="contained-button-file"
                    style={{ marginBottom: "0px" }}
                  >
                    <bouton
                      className={`btn-filter ${this.activeUpload(
                        "depart-tab"
                      )}`}
                      style={{ cursor: "pointer" }}
                      id="depart-tab"
                      onClick={() => this.handleTab("depart-tab")}
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      <span>Parcourir</span>
                    </bouton>
                  </label>
                </div>
              </div>
              <div className="tab-content" id="myTabContent">
                {this.switchTabs(this.state.tabActive)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataPost: state.Communaute.data,
});

export default connect(mapStateToProps, {
  attachFiles,
  openSnackBar,
  attachVideo,
})(MediaPost);
